<template>
	<div class="SpecificProvisionDetail">
		<loading :active="loading" :is-full-page="false" color="#4caf50" data-cy="loading" />
		<div class="container">
			<SpecificProvisionDetailItem :items="tourOperatorsComputed" :title="$t('text.reseller')" :class="{ full: !products?.length && !productGroupsComputed?.length }"  />
			<div v-if="products?.length" class="container__item">
				<span class="container__item-title">{{ $t('text.products') }}</span>
				<table class="container__item-table">
					<thead>
						<th>{{ $t('text.type')}}</th>
						<th>{{ $t('text.service')}}</th>
						<th>{{ $t('text.activation')}}</th>
					</thead>
					<tbody>
						<tr v-for="product of products" :key="product.product_id">
							<td><v-icon style="color: #8F8F8F;">mdi-ticket</v-icon></td>
							<td class=""><p>{{ product.product_sku }}</p><p>{{ product.product_name }}</p></td>
							<td><v-icon v-if="product.product_status === 'activated'" style="color: #64c823;">mdi-check</v-icon><v-icon v-else style="color: #f34545;">mdi-close</v-icon></td>
						</tr>
					</tbody>
				</table>
			</div>
			<SpecificProvisionDetailItem v-if="!products?.length && productGroupsComputed?.length" :items="productGroupsComputed" :title="$t('text.productCategories')" />
		</div>
		<div v-if="products?.length && productGroupsComputed?.length" class="container">
			<SpecificProvisionDetailItem :items="productGroupsComputed" :title="$t('text.productCategories')" />
		</div>
	</div>
</template>

<script>
import Common from '@/mixins/Common.vue'
import Loading from 'vue-loading-overlay'
import SpecificProvisionDetailItem from './SpecificProvisionDetailItem.vue'

export default {
	name: 'SpecificProvisionDetail',
	components: { Loading, SpecificProvisionDetailItem },
	mixins: [Common],
	props: {
		specificProvision: { type: Object, required: true },
		tourOperators: { type: Array, required: true },
		productGroups: { type: Array, required: true },
		serviceProviderId: { type: String, required: true },
		clientId: { type: String, required: true },
	},
	data() {
		return {
			loading: false,
			products: []
		}
	},
	computed: {
		locale() {
			return this.$store.state.serviceLocale ?? 'de'
		},
		tourOperatorsComputed() {
			return this.tourOperators?.filter(x => this.specificProvision.resellers.includes(x.id))
		},
		productGroupsComputed() {
			return this.productGroups?.filter(x => this.specificProvision.productGroups?.includes(x.id))
		}
	},
	methods: {
		async getProducts() {
			if (this.specificProvision.products?.length) {
				this.loading = true
				const productFilters = {
					serviceProviderId: this.serviceProviderId,
					productIds: this.specificProvision.products
				} 
				const r = await this.$httpPost(`/packageTravel/products?clientId=${this.clientId}`, { ...productFilters })
				this.products = r.products
				this.loading = false
			}
		}
	},
	mounted() {
		this.getProducts()
	},
}
</script>

<style lang="scss" scoped>
.SpecificProvisionDetail {
	padding: 32px;
	background-color: #f9f9f9;
	position: relative;
	.container {
		display: flex;
		gap: 24px;

		> .container__item,
		> .SpecificProvisionDetailItem {
			flex: 1;
			min-width: 0;
			&.full {
				flex: 1 1 100%;
			}
		}
		&:nth-child(3) {
			margin-top: 32px;
		}

		&__item {
			&-title {
				display: flex;
				font-size: 17px;
				font-weight: 500;
				line-height: 22px;
				letter-spacing: -0.071px;
				margin-bottom: 16px;
			}
	
			&-table {
				width: 100%;
				border-collapse: collapse;
				> thead {
					border-bottom: 1px solid #e5e5e5;
	
					> th {
						padding: 14px 12px;
						font-size: 15px;
						font-weight: 500;
						line-height: 20px;
						letter-spacing: -0.037px;
						text-align: center;
						&:nth-child(2) {
							text-align: left;
						}
					}
				}
	
				> tbody {
					> tr {
						height: 60px;
						> td {
							padding: 0px 12px;
							text-align: center;
							&:nth-child(2) {
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
								max-width: 0;
								width: 100%;
								text-align: left;
								p {
									white-space: nowrap;
									overflow: hidden;
									text-overflow: ellipsis;
								}
								p:first-child {
									color: #8F8F8F;
									font-size: 12px;
									font-weight: 400;
									line-height: 16px;
									letter-spacing: 0.001px;
								}
						
								p:last-child {
									color: #000;
									font-size: 15px;
									font-weight: 400;
									line-height: 20px;
									letter-spacing: -0.037px;
								}
							}
	
							.v-chip {
								height: 24px;
								border-radius: 4px;
								background: #DBDBDB;
								padding: 0 12px;
								margin-right: 8px;
								font-size: 13px;
								font-weight: 400;
								line-height: 18px;
								letter-spacing: 0.001px;
							}
						}
					}
				}
			}
		}
	}
}
</style>